import React from "react"

import Browse from "../features/browse/Browse"

const IndexPage = () => {
  return <Browse/>
}

export default IndexPage
